import { Component, ElementRef, ViewChild, OnInit, Input } from '@angular/core';
import { trigger, style, transition, animate, AnimationEvent } from '@angular/animations';
import { MegaMenuItem } from 'primeng/api';
import { AppComponent } from './app.component';
import { AppMainComponent } from './app.main.component';
import { MenuItem } from 'primeng/api';
import { AccountService } from './services/AccountService';
import { Router } from '@angular/router';
@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html',
    animations: [
        trigger('topbarActionPanelAnimation', [
            transition(':enter', [
                style({opacity: 0, transform: 'scaleY(0.8)'}),
                animate('.12s cubic-bezier(0, 0, 0.2, 1)', style({ opacity: 1, transform: '*' })),
              ]),
              transition(':leave', [
                animate('.1s linear', style({ opacity: 0 }))
              ])
        ])
    ]
})
export class AppTopBarComponent{
    @Input() user: any;
    activeItem: number;
    
    constructor(public appMain: AppMainComponent,
        public app: AppComponent,
        private accountService: AccountService,
        private router: Router) {
    }

    ngOnInit() {
      
    } 
    
    

    model: MegaMenuItem[] = [
        { label: 'System Deals', icon: '', routerLink: ['/deal/view'] },       
        { label: 'Search', icon: '', routerLink: ['search'] },
        { label: 'Message Board', icon: '', routerLink: ['message/view'] },
        { label: 'Calendar', icon: '', routerLink: ['calendar'] },
        { label: 'Resources', icon: '', routerLink: ['/resource-center/view'] },
        { label: 'Data Mining', icon: '', routerLink: ['datamining-search'] },
    ];

    @ViewChild('searchInput') searchInputViewChild: ElementRef;    

    LogOut() {
        this.accountService.LogOut();
    }    

    public CanShowMenuItem()
    {
        return this.accountService.CanShowMenuItem();
    }

    navigateto(item:string)
    {

        if(item ==='profile'){
            this.router.navigate(['/user/' + this.user.broker.Id])           
        }
        else if(item ==='newdeal'){
            this.router.navigate(['/deal/new'])           
        }
        else if(item ==='viewadmin'){
            this.router.navigate(['/deal/viewadmin'])           
        }
        else if(item ==='reports'){
            this.router.navigate(['/reports'])           
        }
        else if(item ==='datamining'){
            this.router.navigate(['/datamining-search'])           
        }
        else if(item ==='help'){
            this.router.navigate(['/help'])           
        }
        
     
    }

    

}
